import axios from 'axios';
export const baseURL = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
  baseURL,
  timeout: 200000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Interceptor to add token to requests
axiosInstance.interceptors.request.use(
  (config) => {
    // Retrieve user details from localStorage
    const userDetails = localStorage.getItem('user-details');

    if (userDetails) {
      try {
        // Parse the user details and extract the token
        const parsedUserDetails = JSON.parse(userDetails);
        const token = parsedUserDetails.token;

        if (token) {
          // Ensure Bearer format for all authenticated requests
          config.headers['Authorization'] = token.startsWith('Bearer ')
            ? token
            : `Bearer ${token}`;
        }
      } catch (error) {
        console.error('Error parsing user details:', error);
      }
    }

    return config;
  },
  (error) => {
    // Handle request error
    return Promise.reject(error);
  }
);

export default axiosInstance;

// Add a response interceptor to handle 401 Unauthorized
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Clear all localStorage and sessionStorage (same as logout)
      try {
        localStorage.clear();
        sessionStorage.clear();
      } catch (e) {
        console.error('Error clearing storage:', e);
      }
      // Redirect to home page (same as logout)
      if (window.location.pathname !== '/services') {
        window.location.replace('/services');
      }
    }
    return Promise.reject(error);
  }
);
